import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IItinerary } from "@thekilroygroup/shared-ui";
import { IRevalidateResponse } from "../../components/ResponsePopup/responsePopup.interfaces";

export interface ISelectedItinerary {
  itineraries: IItinerary[];
  itineraryFromSearch: IItinerary | null;
  includesBrandedFares: boolean;
  indexOfRequestedItinerary: number;
  brandedFareId: string | null;
  fareId: string | null;
}

const initialState: ISelectedItinerary = {
  itineraries: [],
  itineraryFromSearch: null,
  fareId: null,
  indexOfRequestedItinerary: 0,
  includesBrandedFares: false,
  brandedFareId: null,
};

export const selectedItinerarySlice = createSlice({
  name: "selectedItinerary",
  initialState,
  reducers: {
    setSelectedItineraries: (state, action: PayloadAction<IItinerary[]>) => {
      state.itineraries = action.payload;
    },
    setItineraryFromSearch: (state, action: PayloadAction<IItinerary>) => {
      state.itineraryFromSearch = action.payload;
      state.brandedFareId = action.payload.brandedFare?.fareBasisCode || null;
    },
    setRevalidateResult: (
      state,
      action: PayloadAction<IRevalidateResponse>,
    ) => {
      const { itineraries, includesBrandedFares, indexOfRequestedItinerary } =
        action.payload;
      state.itineraries = itineraries;
      state.includesBrandedFares = includesBrandedFares;

      if (includesBrandedFares) {
        state.indexOfRequestedItinerary =
          indexOfRequestedItinerary > 0 ? indexOfRequestedItinerary : 0;
      }
    },
    setSelectedFareId: (state, action: PayloadAction<string | null>) => {
      state.fareId = action.payload;
    },
    setSelectedBrandedFareId: (state, action: PayloadAction<string | null>) => {
      state.brandedFareId = action.payload;
    },
    setIndexOfRequestedItinerary: (state, action: PayloadAction<number>) => {
      state.indexOfRequestedItinerary = action.payload;
    },
  },
});

export const {
  setSelectedItineraries,
  setItineraryFromSearch,
  setSelectedBrandedFareId,
  setIndexOfRequestedItinerary,
  setRevalidateResult,
  setSelectedFareId,
} = selectedItinerarySlice.actions;
